<template lang="pug">
#green_apet_sheet
  section.banner.position-relative
    div.picture
        img.img-fluid.big(src="img/banner/banner_green_apet_sheet.jpg" alt="banner-certificate")
        img.img-fluid.small(src="img/banner/banner_green_apet_sheet_mobile.jpg" alt="banner-certificate")
    div.mask_banner
    div.breadcrumb_block
      b-container
        b-breadcrumb(:items="breadcrumb_items")
    div.banner_h1
      h1 GREEN APET
  b-container.py-0.py-lg-5.slogan
    p.text-center.font-weight-bolder.py-5 Nan Ya Plastics view protecting the environment as our primary responsibility. To provide a sustainable alternative, we are now introducing GREEN APET, made from Post-Customer Recycled(PCR) resins, achieving lowering the carbon footprint of manufacturing and reducing the impact on environment.
  section#product_profile
    b-row.menu
      b-col.text-center.active APET
    b-container.pt-md-4
      b-row#apet_detail.detail.pb-5.py-md-5.active
        b-col(cols="12" md="8" order="2" order-md="1")
          div
            h3 
              span Product application description
            p GREEN APET uses PCR resins made from recycled PET bottles as its raw material, reducing emissions of carbon and waste, providing consumers with an eco-friendly products.
          div
            h3 
              span Product Features
            ol
              li(v-for="item in a_feature" :key="item.message") {{ item.message }}
          div
            h3 
              span Product Information
            div.pb-2 Three grades according to PCR content:
            ol.mb-0
              li(v-for="item in a_use" :key="item.message") {{ item.message }}
            div.pb-2 For vacuum forming products and packaging such as blisters, trays, folding boxes …etc.
          div
            h3 
              span Product Certificate
            a.linkcus(href="img/certification/GRS_Certificate.pdf" target="_blank")
              figure
                figcaption GRS Certificate
                img(src="img/certification/GRS_Certificate.jpg" alt="GRS Certificate")
        b-col.align-self-center.text-center.pb-5.pb-md-0(cols="12" md="4" order="1" order-md="2")
          swiper.swiper.swiper_product_img(:options="swiperOption_product_img")
            swiper-slide(v-for="item in product_img_data" :key="item.id")
              b-img.w-100(:src="item.img_src",:alt="item.img_alt",:title="item.img_alt" )
            div.swiper-pagination(slot="pagination")
  section#specification.py-5.active
    div.mask
    h2.text-center 
      span  APET Specification
    b-container(fluid)
      swiper.swiper.py-5(:options="swiperOption_apet").swiper_apet.swiper_product_col_3
        swiper-slide(v-for="item in a_specification" :key="item.id")
          ul
              li 
                span(v-html="item.name")
              li 
                span {{ item.feature }}
              li 
                span {{ item.outward }}
              li 
                span(v-html="item.thickness")
              li 
                span(v-html="item.proportion")
              li 
                span(v-html="item.transmittance")
              li 
                span(v-html="item.gloss")
              li 
                span(v-html="item.mist")
        <div class="swiper-pagination" slot="pagination"></div>
  section#others.py-5 
    b-container
      h3 Others
      swiper.swiper.py-5(:options="swiperOption")
        swiper-slide(v-for="item in swiperdata" :key="item.id")
          div
            router-link(:to="item.href_link")
              div
                b-img.w-100(:src="item.url" fluid)
                h5 {{item.name}}
              p.py-4 {{item.text}}
              svg.o_arrow_r(viewbox="0 0 50 30")
                line(x1=0 y1=20 x2=45 y2=20)
                line(x1=45 y1=20 x2=31 y2=8)
        div.swiper-pagination(slot="pagination")
        div.swiper-button-prev(slot="button-prev")
          svg(width="65px" height="65px" viewBox="0 0 65 65" style="transform: scale( 1.75) rotate(180deg)")
            g(id="desktop" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd")
              g(id="product" transform="translate(-1250.000000, -2680.000000)" stroke="#979797")
                  g(id="arrow" transform="translate(1282.500000, 2710.500000) rotate(-180.000000) translate(-1282.500000, -2710.500000) translate(1255.000000, 2683.000000)")
                    circle(stroke-width="1.1" fill="#FFFFFF" cx="27.3493151" cy="27.3493151" r="27.3493151")
                    polyline(stroke-width="3.3" stroke-linecap="round" stroke-linejoin="round" fill="none" points="29.0068493 19.0616438 20.7191781 27.3493151 29.0068493 35.6369863")
        div.swiper-button-next(slot="button-next")
          svg(width="65px" height="65px" viewBox="0 0 65 65" style="transform: scale( 1.75)")
            g(id="desktop" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd")
              g(id="product" transform="translate(-1250.000000, -2680.000000)" stroke="#979797")
                  g(id="arrow" transform="translate(1282.500000, 2710.500000) rotate(-180.000000) translate(-1282.500000, -2710.500000) translate(1255.000000, 2683.000000)")
                    circle(stroke-width="1.1" fill="#FFFFFF" cx="27.3493151" cy="27.3493151" r="27.3493151")
                    polyline(stroke-width="3.3" stroke-linecap="round" stroke-linejoin="round" fill="none" points="29.0068493 19.0616438 20.7191781 27.3493151 29.0068493 35.6369863")
        

</template>
<script>
export default {
    metaInfo: {
        title: 'GREEN APET - NAN YA RIGID FILM',
        titleTemplate: '',
        meta: [
            { name: 'description', content: 'Nan Ya Plastics view protecting the environment as our primary responsibility. To provide a sustainable alternative, we are now introducing GREEN APET, made from Post-Customer Recycled(PCR) resins, achieving lowering the carbon footprint of manufacturing and reducing the impact on environment.' },
            { name: 'Keywords', content: 'Nan Ya Plastics, Rigid Film, APET, GREEN APET, PCR resins' },
            { name: 'og:title', content: 'GREEN APET - NAN YA RIGID FILM' },
            { name: 'og:type', content: 'website' },
            { name: 'og:url', content: 'https://www.nan-ya-pvc.com/' },
            { name: 'og:description', content: 'Nan Ya Plastics view protecting the environment as our primary responsibility. To provide a sustainable alternative, we are now introducing GREEN APET, made from Post-Customer Recycled(PCR) resins, achieving lowering the carbon footprint of manufacturing and reducing the impact on environment.' },
            { name: 'og:image', content: 'https://www.nan-ya-pvc.com/img/OGimage.jpg' },
        ],
    },
  data() {
      return {
        breadcrumb_items: [
          {
            text: 'Home',
            to: { name: 'App' }
          },
          {
            text: 'GREEN APET',
            active: true
          }
        ],
        swiperOption_product_img: {
          slidesPerView: 1,
          pagination: {
            el: '.swiper-pagination',
            clickable: true
          }
        },
        product_img_data: [
          { 
            id: '1',
            img_src: 'img/application_Desktop/green_apet_01.jpg',
            img_alt: 'NAN YA  APET has conductive grades, antistatic grades, static dissipative grades , which can be applied to electronic packaging, industrial packaging, and Tray.' },
          { 
            id: '2',
            img_src: 'img/application_Desktop/green_apet_02.jpg',
            img_alt: 'NAN YA  APET has conductive grades, antistatic grades, static dissipative grades , which can be applied to electronic packaging, industrial packaging, and Tray.' },
          { 
            id: '3',
            img_src: 'img/application_Desktop/green_apet_03.jpg',
            img_alt: 'NAN YA  APET has conductive grades, antistatic grades, static dissipative grades , which can be applied to electronic packaging, industrial packaging, and Tray.' }
        ],
        p_show: [
          {show: true},
          {show: false}
        ],
        a_feature: [
          { message: 'Sheets produced with post-consumer recycled(PCR) PET added, GRS certified.' },
          { message: 'Good in clarity and transparency, less Impurities.' },
          { message: 'Good formability, comparable to virgin APET.' }
        ],
        a_use: [
          { message: 'RA : PCR content 20%' },
          { message: 'RB : PCR content 50%' },
          { message: 'RC : PCR content 90〜100%' }
        ],
        a_specification: [
          { 
            id: '1',
            name: 'GREEN APET <br/> SHEETAVVR-RA',
            feature: 'Features: Obtain GRS certificate、Good formability',
            outward: 'Appearance: Transparent and colored',
            thickness: 'Thickness<sub>(mm)</sub>：0.4',
            proportion: 'S.G.<sub>(g/cm3)</sub>：1.34±0.01',
            transmittance: 'VLT<sub>(transparent products,%)</sub>:<br/><span class="pl-5">84～92</span>',
            gloss: 'Gloss<sub>(transparent products)</sub>：<br/><span class="pl-5">155～165</span>',
            mist: 'Haze<sub>(%)</sub>：3.2↓'},
          { 
            id: '2',
            name: 'GREEN APET <br/> SHEETAVVR-RB',
            feature: 'Features: Obtain GRS certificate、Good formability',
            outward: 'Appearance: Transparent and colored',
            thickness: 'Thickness<sub>(mm)</sub>：0.4',
            proportion: 'S.G.<sub>(g/cm3)</sub>：1.34±0.01',
            transmittance: 'VLT<sub>(transparent products,%)</sub>:<br/><span class="pl-5">82～92</span>',
            gloss: 'Gloss<sub>(transparent products)</sub>：<br/><span class="pl-5">150～165</span>',
            mist: 'Haze<sub>(%)</sub>：3.5↓'},
          { 
            id: '3',
            name: 'GREEN APET <br/> SHEETAVVR-RC',
            feature: 'Features: Obtain GRS certificate、Good formability',
            outward: 'Appearance: Transparent and colored',
            thickness: 'Thickness<sub>(mm)</sub>：0.4',
            proportion: 'S.G.<sub>(g/cm3)</sub>：1.34±0.01',
            transmittance: 'VLT<sub>(transparent products,%)</sub>:<br/><span class="pl-5">80～92</span>',
            gloss: 'Gloss<sub>(transparent products)</sub>：<br/><span class="pl-5">140～165</span>',
            mist: 'Haze<sub>(%)</sub>：4.7↓'}
        ],
        swiperOption_apet: {
          slidesPerView: 3,
          spaceBetween: 30,
          breakpoints: {
            1170: {
              spaceBetween: 30,
              slidesPerView: 'auto',
            },
            991: {
              spaceBetween: 30,
              slidesPerView: 'auto',
              pagination: {
                el: '.swiper-pagination',
                clickable: true
              }
            },
            410: {
              spaceBetween: 10,
              slidesPerView: 'auto',
              pagination: {
                el: '.swiper-pagination',
                clickable: true
              }
            }
          }
        },
        swiperOption: {
          slidesPerView: 3,
          spaceBetween: 51,
          loop: true,
          pagination: {
            el: '.swiper-pagination',
            clickable: true
          },
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
          },
          breakpoints: {
            1024: {
              slidesPerView: 2,
              spaceBetween: 50
            },
            767: {
              slidesPerView: 1,
              spaceBetween: 50
            }
          }
        },
        swiperdata: [
          {
            id:'1',
            name:'Food and Medical use',
            text:'A flat plastic sheet is formed into a three-dimensional curved package by blister equipment which use high temperature and molds, so that consumers can directly see the product and protect it.',
            url:'./img/application_Desktop/other_pic_1.jpg',
            href_link: 'Food-and-medicine'
          },
          {
            id:'2',
            name:'Antistatic Packaging',
            text:'Using blister equipment, using high temperature and molds, the flat plastic sheet is formed into a three-dimensional packaging curved shell, so that consumers can directly see the product and protect it.',
            url:'./img/application_Desktop/other_pic_2.jpg',
            href_link: 'anti_static'
          },
          {
            id:'3',
            name:'Decoration Materials',
            text:'On a continuous substrate, products made through processes such as printing, coating, laminating or pressing. Composite plastic building materials decoration products are made by hot pressing of multi-layer structure, generally 3-5 layer structure laminated, including wear-resistant layer (including UV treatment layer), printed decoration layer, middle material layer, base material layer, etc..',
            url:'./img/application_Desktop/other_pic_3.jpg',
            href_link: 'decoration'
          },
          {
            id:'4',
            name:'Card Lamination',
            text:'This product can be processed into various cards through printing, laminating, card punching, coding, and sub-card quality inspection.',
            url:'./img/application_Desktop/other_pic_4.jpg',
            href_link: 'card_Lamination'
          },
          {
            id:'5',
            name:'For Stationery',
            text:'On a continuous substrate, products made through processes such as printing, coating, laminating or pressing for majority of Printing process.',
            url:'./img/application_Desktop/other_pic_5.jpg',
            href_link: 'office_stationery'
          },
          {
            id:'6',
            name:'Cooling Tower',
            text:'Press working and forming process are good for the product.Forming process has to regulate quality.',
            url:'./img/application_Desktop/other_pic_6.jpg',
            href_link: 'water_treatment'
          },
          {
            id:'8',
            name:'C-PET SHEET',
            text:'C-PET sheet is heated and further processed by compression molding machine so that the molded product can withstand high temperatures after crystallization.',
            url:'./img/application_Desktop/other_pic_8.jpg',
            href_link: 'Cpet-sheet'
          }
        ]
      }
    },
  methods: {
    change:function(item) {
      if(item === 'PVC'){
        this.p_show[0].show = true
        this.p_show[1].show = false
      }
      else{
        this.p_show[1].show = true
        this.p_show[0].show = false
      }
      // for(let i in this.p_show){
      //   this.p_show[i].show = !this.p_show[i].show
      // }
      // this.p_show[0].show = false
      // this.p_show[1].show = true
      // this.p_show = !this.p_show
      // for(let i=0; i<this.p_show.length; i++){
      //   this.p_show[i] = !this.p_show[i]
      //   console.log(i)
      // }
      // console.log(this.p_show[1] + "," + this.p_show[0])
      }
      // if(event){
      //   this.p_show[0] = true
      //   this.p_show[1] = true
      //   console.log(this.p_show[1])}
    // }
  },
}
</script>
<style lang="sass">
@import '@/css/product.sass'
#green_apet_sheet
  #specification
    background-image: url(../assets/bg/bg_green_apet.jpg)
.linkcus,.linkcus:hover
  text-decoration: none
  color: #1E1E1E
  figure
    padding-right: 15px
    text-align: center
    display: inline-block
    figcaption
      padding-bottom : 8px

</style>
